import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaFacebook, FaInstagram, FaRegComment } from "react-icons/fa";
import { LuSmilePlus } from "react-icons/lu";
import { MdOutlineLocationOn } from "react-icons/md";

const CommentsAndHashtags = ({
  editable,
  content,
  setContent,
  values,
  setFieldValue,
}) => {
  return (
    <div className="w-full max-w-xl flex flex-col gap-2">
      <h1 className="font-bold text-sm">Add Caption & Hashtags</h1>
      <div className="flex flex-col gap-[1px]">
        {/* <textarea
          onChange={setContent}
          value={content}
          className="w-full border text-xs border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-1 focus:ring-gray-400 min-h-[50px]"
          placeholder="Type here"
        /> */}

        <Field
          as="textarea"
          name="caption"
          className="w-full border text-xs border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-1 focus:ring-gray-400 min-h-[50px]"
          placeholder="Type here"
          // onChange={(e) => {
          //   // setContent(e.target.value);
          //   // handleChange(e);
          // }}
          disabled={!editable}
        />
        <ErrorMessage
          name="caption"
          component="p"
          className="text-red-500 text-xs mt-1"
        />
        <div className="flex font-bold space-x-3 mt-2 text-xs text-gray-700">
          <span role="img" aria-label="search">
            <FaRegComment />
          </span>
          <span role="img" aria-label="emoji">
            <LuSmilePlus />
          </span>
          <span role="img" aria-label="location">
            <MdOutlineLocationOn />
          </span>
        </div>
      </div>
    </div>
  );
};

export default CommentsAndHashtags;
